import { combineEpics } from 'redux-observable';

const rootEpic = combineEpics(
    // epics come here
);
export default rootEpic;